import { useState as b, useEffect as h } from "react";
const d = { index: 0, length: 0 }, k = {
  bold: !1,
  strike: !1,
  italic: !1,
  link: "",
  list: "",
  table: !1
};
function F(t) {
  const [m, g] = b(k);
  return h(() => {
    const e = () => {
      const n = (t == null ? void 0 : t.getSelection()) || d, { bold: o, strike: a, italic: s, link: c, list: r, table: f } = (t == null ? void 0 : t.getFormat(
        n
      )) || {};
      g({ bold: o, strike: a, italic: s, link: c, list: r, table: f });
    };
    return t == null || t.on("text-change", e), () => {
      t == null || t.off("text-change", e);
    };
  }, [t]), h(() => {
    const e = (n) => {
      const { bold: o, strike: a, italic: s, link: c, list: r, table: f } = (t == null ? void 0 : t.getFormat(
        n || d
      )) || {};
      g({ bold: o, strike: a, italic: s, link: c, list: r, table: f });
    };
    return t == null || t.on("selection-change", e), () => {
      t == null || t.off("selection-change", e);
    };
  }, [t]), m;
}
export {
  k as defaultFormats,
  F as useQuillActiveFormat
};
